import React from 'react';

import { PilledStockItemKeywordLinks } from './StockItemKeyWordLinks';

const RelatedKeywords = ({ keywords, title }) => {
  return (
    <div className="stockItemDetails-row md:col-start-1 md:row-start-2 md:row-end-3 md:col-end-4">
      <div className="stockItemDetails-section">
        <PilledStockItemKeywordLinks keywords={keywords} title={title} />
      </div>
    </div>
  );
};

export default RelatedKeywords;
